import { useState } from 'react';
import AssignTable from './assignTable';
import cn from 'classnames';
import { getStationEmployees } from '@reducers/fireboard/assignEmployee.js';
import { setErrorPopUp } from '@reducers/notification';
import { bindActionCreators } from 'redux';
import style from '@components/Fireboard/components/AssignEmployee/assignEmp.module.scss';
import { connect } from 'react-redux';
import { useNavigate, useOutletContext } from 'react-router-dom';
import constant from '@components/common/globalization';
import HamHeader from '@components/Fireboard/components/Header/HamburgerHeader';
import AssignEmployee from './AssignEmployee';
import Popup from '@components/common/Popup/Popup';
import { PopupContent } from '@components/common/Popup/index';
import { goToView } from '../../../../utility/fireboardUtil';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const EmployeeAssignment = (props) => {
  const { currentView } = props;
  const { popup } = useOutletContext();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('employee');

  const OnChangeTab = key => {
    setSelectedTab(key);
  };

  const tabOptions = [
    { key: 'employee', label: FLABEL().HEADER_EMPLOYEEVIEW },
    { key: 'table', label: FLABEL().HEADER_TABLEVIEW },
  ];

  const Tabs = () => {
    return (
      <div className={cn('d-flex w-50', style.tabContainers)}>
        {tabOptions.map(({ key, label }) => (
          <div
            key={key}
            role="tab"
            aria-selected={selectedTab === key}
            className={cn(
              'col-6 d-flex justify-content-center align-items-center',
              selectedTab === key && style.selectedSensorTab
            )}
            onClick={() => {
              OnChangeTab(key);
            }}
          >
            {label}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <HamHeader
        filterElement={Tabs}
        label={FLABEL().HEADER_ASSIGN_EMPLOYEE}
        onClickback={() => goToView(currentView, navigate)}
      />
      {selectedTab === 'employee' && <AssignTable />}
      {selectedTab === 'table' && <AssignEmployee />}

      <Popup visible={!!popup} fullPopupView={false}>
        <PopupContent {...popup} />
      </Popup>
    </>
  );
};

const mapStateToProps = ({ oauth }) => ({
  currentView: oauth.currentView,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      getStationEmployees,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAssignment);
